const NavBar = () => 'NavBar asd'

export default NavBar;
